import React from 'react'
import {useTranslation} from 'react-i18next'
import {RouteComponentProps} from 'react-router'
import {useHistory} from 'react-router-dom'

import {Box, Typography} from '@mui/material'
import {PGButton} from '@progynyglobal/pg-ui-library'

import {ReactComponent as SpeechBubbleImage} from '@progyny/assets/images/speech-bubble.svg'
import CenteredContainer from '@progyny/components/CenteredContainer'
import {useMeStore} from '@progyny/store/meStore'

const Intro: React.FC<RouteComponentProps> = (props) => {
  const {t} = useTranslation()
  const history = useHistory()

  const user = useMeStore((s) => s.user)
  const {match} = props
  const membersName = user?.member.preferredGivenName || user?.firstName

  return (
    <CenteredContainer>
      <Box
        maxWidth={420}
        display={'flex'}
        justifyContent={'center'}
        flexDirection={'column'}
      >
        <Box display={'flex'} justifyContent={'center'}>
          <SpeechBubbleImage width={170} height={170} />
        </Box>
        <Box
          display={'flex'}
          justifyContent={'center'}
          flexDirection={'column'}
        >
          <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={'center'}
            mt={3}
            mb={2}
          >
            <Typography variant={'h4'}>
              {t('migrate_account_greeting', {membersName})}
            </Typography>
            <Typography variant={'h4'}>
              {t('migrate_account_intro_we_have_some_news')}
            </Typography>
          </Box>
          <Box mb={4}>
            <Typography variant={'body2'} textAlign={'center'}>
              {t('migrate_account_intro_we_ve_added_new_set')}
            </Typography>
          </Box>
          <Typography variant={'body2'} textAlign={'center'}>
            {t('migrate_account_intro_by_answering_following_questions_you')}
          </Typography>
          <Box mt={5} justifyContent={'center'} width={'100%'} display={'flex'}>
            <PGButton
              onClick={() => history.push(`${match.url}/birth-assigned-sex`)}
              label={t('migrate_account_intro_update_your_profile')}
            />
          </Box>
        </Box>
      </Box>
    </CenteredContainer>
  )
}

export default Intro
